import React from "react";
import { X } from "lucide-react";

interface SelectedValueChipsProps {
  selectedValues: string[];
  options: { label: string; value: string }[];
  onRemove: (value: string) => void;
  maxVisible?: number;
  className?: string;
  chipClassName?: string;
  moreClassName?: string;
  labelFormatter?: (option: any) => string; // Custom function to format the label
}

const SelectedValueChips: React.FC<SelectedValueChipsProps> = ({
  selectedValues,
  options,
  onRemove,
  maxVisible = 2,
  className = "",
  chipClassName = "",
  moreClassName = "",
  labelFormatter,
}) => {
  if (selectedValues.length === 0) return null;

  const selectedOptions = options.filter((opt) => selectedValues.includes(opt.value));
  const visibleItems = selectedOptions.slice(0, maxVisible);
  const remainingCount = selectedOptions.length - maxVisible;

  return (
    <div className={`flex items-center gap-1 flex-wrap ${className}`}>
      {visibleItems.map((option) => (
        <div
          key={option.value}
          className={`inline-flex items-center gap-1 px-1 py-0.5 bg-stroke-light text-gray-700 rounded-full text-sm border ${chipClassName}`}
        >
          <span className="truncate max-w-32">{labelFormatter ? labelFormatter(option) : option.label}</span>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onRemove(option.value);
            }}
            className="flex items-center justify-center w-4 h-4 hover:scale-105 rounded-full hover:bg-gray-200 transition-colors"
            aria-label={`Remove ${option.label}`}
          >
            <X className="w-3 h-3" />
          </button>
        </div>
      ))}

      {remainingCount > 0 && (
        <div className={`inline-flex items-center gap-1 px-1 bg-stroke-light text-gray-600 rounded-full text-sm border ${moreClassName}`}>
          +{remainingCount}
        </div>
      )}
    </div>
  );
};

export default SelectedValueChips;
